import { Info } from "lucide-react";

/**
 * InfoNote — küçük "i" ikonu + ortalı bilgilendirme satırı.
 *
 * Hem Karşılama Tam'daki "Bilgilerin aynıysa öneri geçerli." bilgilendirmesi
 * hem Sonuç ekranındaki "Rahat olsun tercihine göre hesapladık." bilgilendirmesi
 * bu component'i kullanır. Sadece children değişir; icon + layout + boyut aynı.
 * Kutu/border yok — inline minimal text.
 */
export const InfoNote = ({ children, testId, animationDelay }) => (
    <div
        className="flex items-center justify-center gap-1.5 text-[12px] text-muted-foreground leading-snug sayz-fms-reveal"
        style={animationDelay ? { animationDelay } : undefined}
        data-testid={testId}
    >
        <Info className="h-4 w-4 text-muted-foreground/60 shrink-0" strokeWidth={1.75} />
        <span>{children}</span>
    </div>
);
